module.exports = __webpack_public_path__ + "img/icon_right_hover.2d3c5157.svg";